import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../core/Button';
import { IconArrowLeft } from '../../icons';
import { getPeriodicityPeriods } from '@allbin/mobilix-utils';
import EntityCheckInRow from './EntityCheckInRow';

interface CheckInPlanInspectionProps {
  plan: CheckInPlan;
  entitiesLookup: Record<string, Entity>;
  onBack: () => void;
}

const CheckInPlanInspection: FC<CheckInPlanInspectionProps> = ({
  plan,
  entitiesLookup,
  onBack,
}) => {
  const periods = getPeriodicityPeriods(plan.periodicity, plan.duration);
  return (
    <>
      <div className="min-h-0 flex-1 overflow-y-auto px-6 pb-5">
        <div className="grid grid-cols-12 items-stretch gap-x-2 pt-3">
          <div className="col-span-6" />
          <div className="col-span-3 flex items-center justify-center">
            <span className="text-base font-semibold leading-6">
              <FormattedMessage
                id="check_in_plan_management.previous_period"
                defaultMessage="Previous period"
              />
            </span>
          </div>
          <div className="col-span-3 flex items-center justify-center">
            <span className="text-base font-semibold leading-6">
              <FormattedMessage
                id="check_in_plan_management.current_period"
                defaultMessage="Current period"
              />
            </span>
          </div>
          {plan.entities.map((entityId, i) => (
            <EntityCheckInRow
              key={entityId}
              entity={entitiesLookup[entityId]}
              periods={periods}
              even={i % 2 === 0}
            />
          ))}
        </div>
      </div>
      <div className="flex shrink-0 flex-row items-center justify-start p-2">
        <Button
          variant="ghost"
          startIcon={<IconArrowLeft />}
          onClick={() => onBack()}
        >
          <FormattedMessage
            id="check_in_plan_management.to_plan_details"
            defaultMessage="Back to check-in plan details"
          />
        </Button>
      </div>
    </>
  );
};

export default CheckInPlanInspection;
